/**
 * Created by razial on 21.09.2026.
 */

Mission.TYPE_EXPEDITION_FEAST = 45;

ManualStarters.ExpeditionFeastStarter = function (type) {
    const location = cleverapps.meta.getSelectedLocation();
    if (!location.isCompleted() && Map2dLocation.currentLocation && Map2dLocation.currentLocation.map.fogs.isOpened("fog6")) {
        if (location.locationId === Missions[type].location) {
            const duration = cleverapps.parseInterval(Missions[type].duration);
            const cooldown = Missions[type].cooldown && cleverapps.parseInterval(Missions[type].cooldown);
            const lastRemoved = cleverapps.missionManager.getLastRemoved(type);

            const locationMeta = cleverapps.meta.getLocationMeta(location.locationId);

            return locationMeta.getTimeLeft() >= duration && (!cooldown || lastRemoved + cooldown < Date.now());
        }
    }
    return false;
};

Mission.REGISTRATIONS.set(Mission.TYPE_EXPEDITION_FEAST, () => ({
    name: "ExpeditionFeast",
    view: ExpeditionFeastWindow,
    startWindow: ExpeditionFeastWindow,
    guideWindow: {
        name: "FeastMissionRulesWindow.ExpeditionFeast",
        title: "ExpeditionFeastWindow.title",
        bundle: "expeditionFeastBundle"
    },
    finishWindow: ExpeditionFeastWindow,
    manualStart: ManualStarters.ExpeditionFeastStarter,
    logic: FeastExpeditionLogic,
    duration: "1 hour",
    cooldown: "1 hour",
    bundle: "lives_feast",
    prize: RewardsConfig.ExpeditionFeast.places,
    mainWorldReward: true,
    sideBarJson: function () {
        return cleverapps.skins.getSlot("expedition_feast_icon_json") || bundles.sidebar.jsons.expedition_feast_icon_json;
    },
    collectIcon: function () {
        return cleverapps.skins.getSlot("expedition_feast_icon") || bundles.reward_icons.frames.expedition_feast_icon;
    },
    sideBarSlotName: "expeditionFeastSideBarIcon",
    competition: {
        step: [2, 2, 2, 3, 3, 3, 5, 5, 5, 10, 10, 12, 12, 15],
        forceCoef: 2,
        amount: [20, 30],
        noPlayerEpisodeCoef: true,
        botAheadPlayerCoef: 0.5,
        offlineCoef: 0.8,
        botAheadPlayerBigDifferenceCoef: 0.3,
        bigDistanceLength: 50
    }
}));
